export interface IApiConfig {
  addUrl: string;
  getUrl: string;
  moveUrl: string;
  updateUrl: string;
  removeUrl: string;
}
